import { useElementsEditForm, UseElementsEditFormFormArgs } from '../../UI/hooks';
import { NoteReceivableFormValues } from '../types';

export const useEditNoteReceivableForm = (args: UseElementsEditFormFormArgs<NoteReceivableFormValues>) =>
  useElementsEditForm<NoteReceivableFormValues>(args);
